import styled from "styled-components";

const DefaultContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 0 40px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export default DefaultContainer;
